import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { useAuth } from '../../hooks/useAuth';
import decryptData from '../../helpers/Decryption';
import { formatDate } from '../../helpers/utils';

const OfferDetail = () => {
    const { getToken } = useAuth();
    const [data, setData] = useState();
    const { state } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Persist state to local storage if available
        if (state) {
            localStorage.setItem('offerDetailState', JSON.stringify(state));
        }
    }, [state]);

    useEffect(() => {
        // Retrieve state from local storage if not available in useLocation
        const savedState = localStorage.getItem('offerDetailState');
        const parsedState = savedState ? JSON.parse(savedState) : null;

        if (state?.offer_id && state?.offer_detail) {
            setData(state.offer_detail);
        } else if (parsedState?.offer_id && parsedState?.offer_detail) {
            setData(parsedState.offer_detail);
        } else {
            getOfferDetail(parsedState?.offer_id);
        }
    }, [state]);

    useEffect(() => {
        return () => {
            // Clear local storage state when navigating away
            localStorage.removeItem('offerDetailState');
        };
    }, []);

    const getOfferDetail = async (id) => {
        const token = getToken();
        if (token && id) {
            new WebApiCalls()
                .getOfferDetails(token, id)
                .then(async (res) => {
                    if (res?.code === 200) {
                        const offerData = await decryptData(res.data);
                        setData(offerData);
                    }
                })
                .catch((err) => console.error('Error fetching offer details:', err));
        }
    };

    return (
        <>
            <Row className="justify-content-end align-items-center">
                <Col sm={4} md={3} className="text-center">
                    <div>
                        <Button
                            onClick={() =>
                                navigate(state.redirect_url, {
                                    state: {
                                        branch_id: state.branch_id,
                                        branch_detail: state.branch_detail,
                                        redirect_url: '/rewards'
                                    }
                                })
                            }
                            className="theme-cancel-btn px-5 py-2"
                        >
                            Close
                        </Button>
                    </div>
                </Col>
            </Row>
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="p-4 m-3">
                    <Row>
                        <Col md={3}>
                            <div className="detail-small-heading">Name</div>
                            <div className="detail-value">{data?.name}</div>
                        </Col>
                        <Col md={3}>
                            <div className="detail-small-heading">Reward Type</div>
                            <div className="detail-value">{data?.offerType}</div>
                        </Col>
                        <Col md={3}>
                            <div className="detail-small-heading">Time Range</div>
                            <div className="detail-value">
                                {data?.timeRange?.start} - {data?.timeRange?.end}
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md={3}>
                            <div className="detail-small-heading">Start Date</div>
                            <div className="detail-value">{formatDate(data?.startDate)}</div>
                        </Col>
                        <Col md={3}>
                            <div className="detail-small-heading">End Date</div>
                            <div className="detail-value">{formatDate(data?.endDate)}</div>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md={12}>
                            <div className="detail-small-heading">Branches</div>
                            <table className="table table-bordered detail-value">
                                <thead>
                                    <tr>
                                        <th className="text-center">#</th>
                                        <th>Name</th>
                                        <th>Location</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.branches?.map((branch, index) => (
                                        <tr key={branch._id}>
                                            <td className="text-center">{index + 1}</td>
                                            <td>{branch.name}</td>
                                            <td>{branch.address}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md={12}>
                            <div className="detail-small-heading">Menu Item</div>
                            <table className="table table-bordered detail-value">
                                <thead>
                                    <tr>
                                        <th className="text-center">#</th>
                                        <th>Name</th>
                                        <th>Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.menuItem && (
                                        <tr>
                                            <td className="text-center">1</td>
                                            <td>{data.menuItem.itemName}</td>
                                            <td>{data.menuItem.price}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default OfferDetail;
